import { Backdrop, DevelopmentBar, Flex, InactiveSubscriptionBanner } from 'components'
import { useCurrentUser, WorkspaceProvider } from 'components/providers'
import { Outlet } from 'react-router'
import { useInitEntevatePermission } from 'utils'
import { ResourceProvider } from '../ResourceProvider'
import { DevelopmentBarAction, IntercomProvider, SideMenu, TopBar } from '../components'

export default function RootPage() {
  const user = useCurrentUser()
  useInitEntevatePermission()

  return (
    <WorkspaceProvider>
      <ResourceProvider>
        <IntercomProvider user={user}>
          <Backdrop flexDirection="column" flex="auto" overflow="hidden">
            <DevelopmentBar action={<DevelopmentBarAction />} />
            <InactiveSubscriptionBanner />
            <Flex
              flex={1}
              direction="row"
              overflow="hidden"
              ml={{ base: 0, md: 4 }}
              gap={{ base: 0, md: 4 }}
              pt={{ base: 'calc(env(safe-area-inset-top))', md: 0 }}
              pb={{ base: 'calc(env(safe-area-inset-bottom))', md: 0 }}
            >
              <SideMenu />
              <Flex flex="auto" direction="column" overflow="hidden">
                <TopBar />
                <Outlet />
              </Flex>
            </Flex>
          </Backdrop>
        </IntercomProvider>
      </ResourceProvider>
    </WorkspaceProvider>
  )
}
